import store from '@/modules/laboratoryModule/sideBar/laboratorySideBarStore'

export default {
    name: 'LaboratoryStateMixin',
    data() {
        return {
            state: store.state
        }
    },
    computed: {
        sectionIds() {
            return this.state.sectionIds
        },
        selectedOption() {
            return this.state.selectedOption
        }
    }
}
